import React from 'react'


import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';

function Terms() {
  return (
    <div>


<SEO title="Terms & Conditions Page"/>

<Header/>

<div class="aboutarea__5 sp_bottom_100">
            <div class="container">
                <div class="row">

                <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 mx-auto">


<div class="blog__details__content__wraper">

    <div class="course__list__wraper aos-init aos-animate" data-aos="fade-up">

    <div class="blog__details__heading__2">
            <h3>Terms and Conditions</h3>
            <h6>Effective Date : 01-04-2025</h6>
        </div>
    

<div class="experence__description">
                    <p class="description__1">Welcome to <strong className='text-white'>Trading Whales.</strong> By accessing or using our website, services, or content, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully.
                    </p>
                    <h5>1. Acceptance of Terms</h5>
                    <p class="description__2">By enrolling in our courses, accessing any content, or using our services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
                    </p>
                    <h5>2. Services Provided</h5>
                    <p class="description__3">
                    Trading Whales offers educational content, training programs, and resources related to stock market trading, investing, and financial planning through online and offline modes.</p>
                    
                    
                    <h5>3. Eligibility</h5>
                    <p className='description_3'>Our services are intended for individuals aged 18 years and above. By using our platform, you confirm that you meet this requirement.</p>
                    
                    <h5>4. No Investment Advice</h5>
                    <p className='description_3'>All content provided by Trading Whales is strictly for educational purposes. We do not offer any financial, investment, or trading advice. Decisions made based on our content are at your own risk.
                    </p>
                    
                    <h5>5. Intellectual Property</h5>
                    <p className='description_3'>All course materials, content, videos, PDFs, logos, and trademarks are the intellectual property of Trading Whales. Unauthorized use, reproduction, or distribution is strictly prohibited.
                    </p>
                    
                    <h5>6. Payments and Refunds</h5>
                    <p className='description_3'>All course payments are non-refundable unless explicitly mentioned under a promotional offer. Please review the refund policy on the course detail page before enrolling.
                    </p>
                    
                    <h5>7. User Conduct</h5>
                    <p className='description_3'>Users must not misuse the website or content. You agree not to hack, spam, or interfere with our system or other users. Any violation may lead to termination of access.
                    </p>
                    
                    <h5>8. Account Security</h5>
                    <p className='description_3'>You are responsible for maintaining the confidentiality of your account credentials. Trading Whales is not liable for any loss or damage resulting from unauthorized access.
                    </p>
                    
                    <h5>9. Third-Party Tools and Links</h5>
                    <p className='description_3'>We may use third-party platforms for hosting webinars, payments, or learning management. We are not responsible for the content, policies, or practices of these third parties.
                    </p>
                    
                    <h5>10. Limitation of Liability</h5>
                    <p className='description_3'>Trading Whales is not liable for any losses or damages incurred as a result of applying information obtained from our courses or materials.
                    </p>

                    <h5>11. Modifications to Terms</h5>
                    <p className='description_3'>We reserve the right to update these Terms at any time without prior notice. Continued use of our services after changes constitutes acceptance of the new terms.
                    </p>

                    <h5>12. Governing Law</h5>
                    <p className='description_3'>These Terms and Conditions are governed by the laws of India. Any disputes arising shall be resolved in the courts located in Hyderabad, Telangana.
                    </p>

                    <h5>13. Contact Us</h5>
                    <p className='description_3'>If you have any questions regarding these Terms, please contact us at:
                    </p>
                    <a href="mailto:info@tradingwhales.in">info@tradingwhales.in</a> <br />
                    <a href="tel:+91 94910 65567">+91 94910 65567</a>



                     </div>

    </div>



</div>
</div>


 </div>
 </div>         
       </div>




<Footer/>
      

    </div>
  )
}

export default Terms
